import { memo } from 'react';
import { useSelector } from 'react-redux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { IncentiveTotalsView } from './IncentiveTotalsView';

export const RebatesTotals = memo(function RebatesTotals() {
    const dealerCashTotal = useSelector(offerReduxSelectors.getAppliedIncentivesTotalForDealerCash);
    const rebatesTotal = useSelector(offerReduxSelectors.getAppliedIncentivesTotalForDisplay);
    const isCalculating = useSelector(offerReduxSelectors.isCalculatingPayment);

    return <IncentiveTotalsView dealerCashTotal={dealerCashTotal} incentivesTotal={rebatesTotal} isCalculating={isCalculating} />;
});
